import bridge from '../utiles/bridge';
import {
  getJSON,
  getHrefParam,
  PASSPORT_HOST,
  HOST,
  ERR_CODE,
  post,
  get,
  SUPPORT_REQ_URL
} from './ultile';

import { encryption, statsRequest } from '../utiles';
import { HIDE_DIALOG, SHOW_DIALOG, BINDING_DIALOG, TOST } from './dialog';
import { isAndroid } from '../utiles/device';
import globalConfig from '../utiles/globalConfig';
import { validateMigrateCode, validateSwitchMigrateCode } from './validator';
import { trackStagePoint } from '@utiles/store/speedPoint';
export const BIND_STATE = 1;
export const DEBIND_STATE = 0;
export const GIST_REWARD = 1;
export const GIST_NOT_EWARD = 0;
export const SWITCH_ACCOUNT = 'switchAccount';
export const DESTROY_ACCOUNT = 'destroyAccount';
export const RECOVERY_ACCOUNT = 'recoveryAccount';
export const CHECK_OPEN_DELETE = 'checkOpenDelete';
export const INIT_BY_SDK = 'initBySdk';
export const PAGE_INIT = 'initPageInfo';
export const BIND_ACCOUNT = 'bindAccount';
export const DEBIND_ACCOUNT = 'debindAccount';
export const GET_BIND_REWARD = 'getBindReward';
export const CHECK_BIND_REWARD = 'checkBindReward';
export const REFRESH_LOGIN_STATUS = 'refreshLoginStatus';
export const CHANGE_PAGE_INIT_STATE = 'changePageInitState';
export let PAGED_INITED = false;
export let PAGED_INITING = false;
export const LOGIN = 'login';
export const CHANGE_USER_INFO = 'changeUserInfo';
export const CHANGE_IS_BIND_EMAIL = 'changeIsBindEmail';
export const LOGOUT = 'logout';
export const RESET_EMAIL = 'resetEmail';
export const SWTICH_ACCOUNT = 'switchAccount';
export const SWTICH_BY_MIGRATE = 'switchAccountByMigrateCode';
export const CHECK_FLOAT_SDK_PARAM = 'checkFloatSdkParam';
export const CLEAR_RED_POINT = 'clearRedPoint';
export const GET_NOTICE_POPUP = 'getNoticePopup';
export const SEND_SHOW_NOTICE_RECORD = 'sendShowNoticeRecord';
export const GET_MODS_POPUP = 'getModsPopup';
export const UPDATE_PLATFORM_ACCOUNT_BIND = 'updatePlatformAccountBind';
export const UPDATE_PLATFORM_ACCOUNT_TYPE = 'updatePlatformAccountType';
export const UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE =
  'updatePlatformAccountPopupVisible';
export const UPDATE_PLATFORM_ACCOUNT_UNBIND = 'updatePlatformAccountUnBind';
export const GET_PLATFORM_EMAIL_CODE = 'getPlatformEmailCode';
export const GET_PLATFORM_PHONE_CODE = 'getPlatformPhoneCode';
export const BIND_PLATFORM_EMAIL = 'bindPlatformEmail';
export const BIND_PLATFORM_PHONE = 'bindPlatformPhone';
export const GET_PLATFORM_BIND_INFO = 'getPlatformBindInfo';
let logined = false;
const REFREH_ACTION = 'center/ajax/refresh_user_json';
const GET_MIGRATE_ACTION = 'migrate_code/get';
const GENERATE_MIGRATE_ACTION = 'migrate_code/generate';
const DESTROY_ACCOUNT_ACTION = 'center/destory_user';
const RECOVERY_ACCOUNT_ACTION = 'center/destory_user/resume';
const GET_USER_SUB_ACTION = 'center/destory_user/getUserSub';
const UNABLE_TOKEN_ACTION = 'center/destory_user/unableToken';
export const GET_USER_SUB = 'getUserSub';
export const IOS_REVOKE = 'iosRevoke';
const CHECK_LOGIN = 'center/ajax/get_store_user_json';
const DEFAULT_AVATAR = '';
const INIT_USER_INFO = 'initUserInfo';
export const INIT_BIND_INFO = 'initBindInfo';
const INIT_BIND_SUPPORT = 'initBindSupport';
const SET_LOGIN_PATH = 'setLoginPath';
export const GET_MIGRATE = 'getMigrate';
export const GENERATE_MIGRATE = 'generateMigrate';
let roleName = getHrefParam('roleName');
let userName = getHrefParam('loginAccount') || getHrefParam('userName');
let hrefLoginAccount = getHrefParam('loginAccount');
const IOS = 'ios';
const ANDROID = 'android';
const device = isAndroid() ? ANDROID : IOS;
const SET_FOLLOW_CODE = 'setFollowCode';
const SET_IS_BIND_STATE = 'setIsBindState';
const SET_ALLOW_BIND_STATE = 'setAllowBindState';
export const DETECT_LOGIN = 'detectLogin';
export const CHECK_DEBIND = 'checkDebind';
export const DO_DEBIND = 'doDebind';
const INIT_IS_BINDED = 'intIsBinded';
const UPDATE_BIND_INFO = 'updateBindInfo';
export const GET_CAN_DEBIND_TYPE = 'getCanDebindType';
const SET_CAN_DEBIND_TYPE = 'setCanDebindType';
export const UPDATE_DMA_SELECT = 'updateDmaSelect';
export const UPDATE_KR_TERMS_SELECT = 'updateKrTermsSelect';
export const UPDATE_US_TERMS_SELECT = 'updateUsTermsSelect';
const DMA_SELECT = 'dmaSelect';
const KR_TERMS_SELECT = 'krTermsSelect';
const US_TERMS_SELECT = 'usTermsSelect';
export default {
  state: {
    fb: {
      status: DEBIND_STATE,
      nickName: ''
    },
    gp: {
      status: DEBIND_STATE,
      nickName: ''
    },
    tw: {
      status: DEBIND_STATE,
      nickName: ''
    },
    ln: {
      status: DEBIND_STATE,
      nickName: ''
    },
    hw: {
      status: DEBIND_STATE,
      nickName: ''
    },
    nv: {
      status: DEBIND_STATE,
      nickName: ''
    },
    gc: {
      status: DEBIND_STATE,
      nickName: ''
    },
    ap: {
      status: DEBIND_STATE,
      nickName: ''
    },
    mg: {
      status: DEBIND_STATE,
      nickName: ''
    },
    vk: {
      status: DEBIND_STATE,
      nickName: ''
    },
    em: {
      status: DEBIND_STATE,
      nickName: ''
    },
    ph: {
      status: DEBIND_STATE,
      nickName: ''
    },
    bindSupportArr: [], // 绑定账号渠道数组映射表
    giftStatus: GIST_NOT_EWARD,
    canGetGift: GIST_NOT_EWARD,
    userName: userName,
    serverName: '',
    roleName,
    avatar: '',
    binded: false,
    pageInited: false,
    errMsg: '',
    showExchange: 0,
    logined: false,
    loginPath: '',
    displayName: userName,
    logginAccount: '',
    userId: '',
    email: '',
    isBindThird: false,
    oldFollowCode: '',
    isAllowBindState: 0, // 是 否启用绑定领奖 0不启用 1启用
    isBindRewardState: 0, // 是否已经领奖，0未领奖 1已领奖
    isBindEmail: 0, // 是否绑定正确的邮箱
    canDebindType: [], // 可解绑账号类型
    isPlatformAccountBind: false, // 是否平台账号绑定true | 登录false
    isPlatformAccountUnBind: false, // 是否平台账号解绑，是true | 否false
    platformAccountType: 'em', // 平台账号类型 em邮箱 | ph手机
    visiblePlatformAccountPopup: false, // 是否展示平台账号弹窗
    visibleSwitchEmailAccount: false, // 是否展示切换邮箱平台账号入口
    dmaEnterBtn: false, // 是否展示dma入口
    useDmaPopup: true, // 1是自己页面，2是第三方
    dmaSelect: globalConfig.getCookie(DMA_SELECT) || '0', // 用户中心默认选项
    krTermsEnterBtn: false, // 是否展示韩国协议入口，0不展示，1或2展示
    krTermsSelect: globalConfig.getCookie(KR_TERMS_SELECT) || '0', // 用户中心默认选项
    usTermsEnterBtn: false, // 是否展示美国地区协议入口，0不展示，1或2展示
    usTermsSelect: globalConfig.getCookie(US_TERMS_SELECT) || '0', // 用户中心默认选项
    passportToken: ''
  },
  mutations: {
    [UPDATE_PLATFORM_ACCOUNT_BIND](state, bool) {
      state.isPlatformAccountBind = bool;
    },
    [UPDATE_PLATFORM_ACCOUNT_UNBIND](state, bool) {
      state.isPlatformAccountUnBind = bool;
    },
    [UPDATE_PLATFORM_ACCOUNT_TYPE](state, type) {
      state.platformAccountType = type;
    },
    [UPDATE_PLATFORM_ACCOUNT_POPUP_VISIBLE](state, bool) {
      state.visiblePlatformAccountPopup = bool;
    },
    [INIT_USER_INFO](state, userInfo) {
      state.avatar = (userInfo && userInfo.avatar) || DEFAULT_AVATAR;
      state.roleName = userInfo ? userInfo.roleName : '';
      state.serverName = userInfo ? userInfo.serverName : '';
      state.dmaEnterBtn =
        userInfo && userInfo.consentType !== undefined
          ? +userInfo.consentType !== 0
          : false;
      state.useDmaPopup =
        userInfo && userInfo.consentType !== undefined
          ? +userInfo.consentType === 1
          : true;
      state.dmaSelect =
        userInfo && userInfo.consentMode !== undefined
          ? userInfo.consentMode
          : '0';
      state.krTermsEnterBtn = !!(userInfo && userInfo.krPersonalizedAdsTerm);
      state.krTermsSelect = (userInfo && userInfo.krPersonalizedAdsTerm) ? userInfo.krPersonalizedAdsTerm : '0';
      state.usTermsEnterBtn = !!(userInfo && userInfo.usPersonalizedAdsTerm);
      state.usTermsSelect = (userInfo && userInfo.usPersonalizedAdsTerm) ? userInfo.usPersonalizedAdsTerm : '0';
    },
    [INIT_BIND_INFO](state, bindInfo) {
      for (var i = 0, len = bindInfo.length; i < len; i++) {
        var type = bindInfo[i]?.bind_type;
        if (!state[type]) {
          continue;
        }
        state[type].status = bindInfo[i].bind_status;
        state[type].nickName = bindInfo[i].nick_name;
      }
      this.commit(INIT_IS_BINDED);
    },
    [INIT_IS_BINDED](state) {
      let fbBinded = state['fb'].status == BIND_STATE;
      let twBinded = state['tw'].status == BIND_STATE;
      let gcBinded = state['gc'].status == BIND_STATE;
      let gpBinded = state['gp'].status == BIND_STATE;
      let hwBinded = state['hw'].status == BIND_STATE;
      let vkBinded = state['vk'].status == BIND_STATE;
      let emBinded = state['em'].status == BIND_STATE;
      let phBinded = state['ph'].status == BIND_STATE;
      let iosBinded =
        device === IOS &&
        (fbBinded || twBinded || gcBinded || vkBinded || emBinded || phBinded);
      let androidBinded =
        device === ANDROID &&
        (fbBinded ||
          twBinded ||
          gpBinded ||
          hwBinded ||
          vkBinded ||
          emBinded ||
          phBinded);
      state.binded = iosBinded || androidBinded;
    },
    [UPDATE_BIND_INFO](state, info) {
      if (!state[info?.type]) {
        return;
      }
      state[info.type].status = info.status;
      this.commit(INIT_IS_BINDED);
    },
    [INIT_BIND_SUPPORT](state, bindSupportArr) {
      state.bindSupportArr = bindSupportArr;
    },
    [CHANGE_PAGE_INIT_STATE](state) {
      state.pageInited = true;
    },
    [LOGIN](state) {
      state.logined = true;
    },
    [CHANGE_USER_INFO](state, userInfo) {
      state.displayName =
        userInfo['DISPLAY_NAME'] ||
        state.displayName ||
        hrefLogginAccount ||
        state.logginAccount;
      state.logginAccount =
        userInfo['LOGIN_ACCOUNT'] || hrefLogginAccount || state.logginAccount;
      state.userId = userInfo['UID'];
      state.email = userInfo['EMAIL'] || state.email;
      state.isBindThird =
        userInfo['IS_BIND_THIRD'] == 1 || state.isBindThird == 1;
      localStorage.setItem('userId', state.userId);
      localStorage.setItem('displayName', state.displayName);
      state.passportToken = userInfo['PASSPORT_TOKEN'] || '';
    },
    [CHANGE_IS_BIND_EMAIL](state, tag) {
      state.isBindEmail = tag;
    },
    [RESET_EMAIL](state, email) {
      state.email = email;
    },
    [SET_LOGIN_PATH](state, loginPath) {
      state.loginPath = loginPath;
    },
    [SET_FOLLOW_CODE](state, code) {
      state.oldFollowCode = code;
    },
    [SET_IS_BIND_STATE](state, newValue) {
      state.isBindRewardState = newValue;
    },
    [SET_ALLOW_BIND_STATE](state, newValue) {
      state.isAllowBindState = newValue;
    },
    [SET_CAN_DEBIND_TYPE](state, type) {
      state.canDebindType = type;
    },
    [UPDATE_KR_TERMS_SELECT](state, value) {
      state.krTermsSelect = String(value);
    },
    [UPDATE_US_TERMS_SELECT](state, value) {
      state.usTermsSelect = String(value);
    },
    [UPDATE_DMA_SELECT](state, value) {
      state.dmaSelect = String(value);
    }
  },
  actions: {
    [DETECT_LOGIN]() {
      return new Promise(resolve => {
        if (
          (globalConfig.getHrefParam('gameId') == 215 ||
            globalConfig.getHrefParam('game_id') == 215 ||
            globalConfig.getHrefParam('gameID') == 215) &&
          globalConfig.isUidGame()
        ) {
          resolve(1);
          return;
        }
        getJSON(PASSPORT_HOST + CHECK_LOGIN, {}).then(res => {
          logined = parseInt(res.res.result, 10) === 1;
          resolve(parseInt(res.res.result, 10) === 1);
        });
      });
    },
    [LOGIN]({ commit, dispatch }, loginPath) {
      return new Promise(resolve => {
        if (logined) {
          if (window?.isSelectPage) {
            trackStagePoint('store_login_logined');
          }
          resolve({
            logined,
            errmsg: ''
          });
        } else {
          if (window?.isSelectPage) {
            // trackStagePoint('store_login_not_logined');
          }
          loginPath = loginPath.replace(/\&type\=0\&/, '&type=1&');
          let forward = encodeURIComponent(globalConfig.getCurrentHref());
          return getJSON(loginPath, {
            forward,
            needntEntryParam: true,
            type: 1
          }).then(res => {
            const { errmsg, data } = res;
            if (window?.isSelectPage) {
              trackStagePoint('store_get_login_path_complete', {
                errmsg,
              });
            }
            if (errmsg === '') {
              commit(LOGIN, data);
              dispatch(INIT_BIND_INFO);
              commit(CHANGE_USER_INFO, data);
              logined = true;
            }
            resolve({ logined, errmsg, data });
          });
        }
      });
    },
    [PAGE_INIT]({ commit, dispatch, state }, hideDialog = true) {
      const successMock = {
        code: 1,
        result: 1,
        data: {
          bind_info: [
            {
              bind_status: '1',
              nick_name: '',
              bind_type: 'fb'
            },
            {
              bind_status: '1',
              nick_name: '',
              bind_type: 'tw'
            },

            {
              bind_status: '1',
              nick_name: '',
              bind_type: 'gc'
            },
            {
              bind_status: '1',
              nick_name: '',
              bind_type: 'gp'
            },
            {
              bind_status: '0',
              nick_name: '',
              bind_type: 'nv'
            },
            {
              bind_status: '0',
              nick_name: '',
              bind_type: 'ln'
            },
            {
              bind_status: '1',
              nick_name: '',
              bind_type: 'ap'
            }
          ],
          userInfo: {
            roleName: '소환사227',
            loginAccount: 'MVFN:1000005149',
            serverId: '5',
            serverName: '',
            userId: '1000005149',
            avatar: '',
            krPersonalizedAdsTerm: '', // 韩国个性化广告协议 空不展示 0:未勾选 1:已勾选
            usPersonalizedAdsTerm: '', // 美国个性化广告协议 空不展示 0:未勾选 1:已勾选
            consentType: '1',
            consentMode: '0'
          },
          // 绑定账号显示的渠道，分别表示：facebook,twitter,line,followCode引继码,naver,googleplay,gamecenter
          bind_support: ['fb', 'tw', 'ln', 'mg', 'ap'],
          loginPath:
            'https://gpassport.endomainname.com/login/dirLogin?CacheToken=0&Isdblink=0&advertiser=global&appLanguage=vi-VN&apps=1599661142160-0068154&battery=10&country=US&deepLinkURL=&devicePlate=ios&gameAppVersion=1&gameCode=slvn&gameId=195&idfa=07DB6417-544A-48E0-9E0F-8FE8E5CAFBBD&isFirst=0&isJailBroken=0&jgPid=&language=en-US&loginToken=d536fe31bca24b883fa50f9f89c5eabe68d24f409211d2111f02ca38dbd13673c9d2efe86650eb9e0bb01f4209fb632e191181194263df9056d62c87499cd2357c3adca10cf509a2f0a96364c61ef9ab&loginType=mac&mac=020000000000&netType=wifi&originalIdfa=82F7EAD8-1AE1-48A7-86DD-2DE4BF2E9139&originalIdfv=80567C38-E24A-4BA1-AD10-227564D19699&originalLanguage=en-TH&originalModel=iPhone10%2C3&osVersion=13.6.1&packageName=com.vn.sl.ios&packageVersion=41&phoneModel=iPhone%20X&play_id=1fe31f07159c526706a6780afc0f409b&ptCode=global&publishPT=appstore&ratio=2436.0%2A1125.0&referer=tw0002&roleLevel=&sdkVersion=v6.8.18&sdkZoneId=1&serverId=50319&sign=f3ea73d48f2a02be3565a0fae91ec6c5&timeStamp=1601264647556&timeZone=GMT%2B8&uid=1000005368&forward=https%3A%2F%2Fgabres.endomainname.com%2Fplatform%2Fpassport.html%3FCacheToken%3D0%26Isdblink%3D0%26advertiser%3Dglobal%26appLanguage%3Dvi-VN%26apps%3D1599661142160-0068154%26battery%3D10%26country%3DUS%26deepLinkURL%3D%26devicePlate%3Dios%26gameAppVersion%3D1%26gameCode%3Dslvn%26gameId%3D195%26hideSDKLogo%3D0%26idfa%3D07DB6417-544A-48E0-9E0F-8FE8E5CAFBBD%26isFirst%3D0%26isJailBroken%3D0%26jgPid%3D%26language%3Den-US%26loginAccount%3DMVFN%253A1000005368%26loginType%3Dmac%26mac%3D020000000000%26netType%3Dwifi%26originUserType%3D4%26originalIdfa%3D82F7EAD8-1AE1-48A7-86DD-2DE4BF2E9139%26originalIdfv%3D80567C38-E24A-4BA1-AD10-227564D19699%26originalLanguage%3Den-TH%26originalModel%3DiPhone10%252C3%26osVersion%3D13.6.1%26packageName%3Dcom.vn.sl.ios%26packageVersion%3D41%26phoneModel%3DiPhone%2520X%26play_id%3D1fe31f07159c526706a6780afc0f409b%26portrait%3D0%26ptCode%3Dglobal%26publishPT%3Dappstore%26ratio%3D2436.0%252A1125.0%26referer%3Dtw0002%26roleId%3D36082826633807350%26roleLevel%3D%26roleName%3DH%25E1%25BA%25A3iThy%26sdkToken%3Dglobalslvtlink%26sdkVersion%3Dv6.8.18%26sdkZoneId%3D1%26serverId%3D50319%26skinBrand%3Dfuntap%26timeStamp%3D1601264646533%26timeZone%3DGMT%252B8%26userMode%3D1%26userName%3D1000005368%26zone%3Dvi-VN%23%2Fhome&needntEntryParam=true&type=1&language=en-US&appLanguage=vi-VN&callback=jsonpCallback0'
        }
      };
      return new Promise((resolve, reject) => {
        // 前端调用sdk 的方法。
        // 第二个参数为sdk 回调，回调参数格式前端与sdk两者约定
        // 第三个参数为 非 sdk 环境下（测试环境），用来模拟的假数据
        bridge.callSdkMethod(
          PAGE_INIT,
          function (res) {
            if (res.result === ERR_CODE) {
              commit(HIDE_DIALOG);
              // dispatch(SHOW_TIPS_MSG, { message: res?.msg });
              reject(new Error(res?.msg));
            } else {
              commit(INIT_USER_INFO, res.data.userInfo);
              // 因加上解绑功能，解绑之后，未重新进游戏时，二次进入用户中心无法更新绑定状态，改为前端读取接口初始化绑定状态
              // commit(INIT_BIND_INFO, res.data.bind_info);
              state.logined && dispatch(INIT_BIND_INFO);
              let bindSupport = [];
              if (
                res.data.hasOwnProperty('bind_support') &&
                res.data.bind_support.length
              ) {
                bindSupport = res.data.bind_support;
              } else {
                /**
                 * 智轩：如果是要兜底的话，我建议只保留这四个:
                 * FB（安卓/iOS都有）、GP（安卓/iOS都有）、APPLE（iOS）、GC（iOS）
                 */
                bindSupport =
                  device === ANDROID
                    ? ['fb', 'gp'] // 安卓
                    : ['fb', 'gp', 'ap', 'gc']; // iOS
              }

              /**
               * 2024.1.9 蚂蚁全球包台湾地区开启邮箱绑定功能，不开切换账号。因为SDK没有更新，切换需要SDK支持
               * 由于这个bindSupport是同时控制绑定和切换登录的还需要Ocean UI的SwitchAccount在文件中加个变量hideSwitchEmail判断
               * 如果SDK支持了要加上切换账号功能，这些代码可以删除了
               */
              if (bindSupport.includes('em')) {
                state.visibleSwitchEmailAccount = true;
              }
              if (
                !bindSupport.includes('em') &&
                getHrefParam('gameId') === '263' &&
                (getHrefParam('packageName') === 'com.global.antgame' ||
                  getHrefParam('packageName') === 'com.global.antgame.ios')
              ) {
                bindSupport.push('em');
                state.visibleSwitchEmailAccount = false;
              }

              commit(INIT_BIND_SUPPORT, bindSupport);
              // commit(INIT_BIND_SUPPORT, ['fb','tw','ln','mg'] );

              // ios 和安卓传递的参数格式没有统一
              commit(SET_LOGIN_PATH, res.loginPath || res.data.loginPath);
              hideDialog && commit(HIDE_DIALOG);
              // ios 和安卓传递的参数格式没有统一
              // 2022.11.11 邓智轩：PNS目前需要强推绑定第三方账号功能，需要通用配置链接参数直接弹出绑定功能，引导玩家去绑定。
              if (+globalConfig.getHrefParam('showBindDialog') === 1) {
                dispatch(SHOW_DIALOG, BINDING_DIALOG);
              }
              resolve(res.loginPath || res.data.loginPath);
            }
            commit(CHANGE_PAGE_INIT_STATE);
          },
          successMock
        );
      });
    },
    [INIT_BIND_INFO]({ commit }) {
      return new Promise((resolve, reject) => {
        getJSON(PASSPORT_HOST + 'center/ajax/get_user_bind_info_json', {
          gameId:
            getHrefParam('gameId') ||
            getHrefParam('gameID') ||
            getHrefParam('game_id') ||
            ''
        }).then(({ errmsg, res }) => {
          if (errmsg) {
            reject({ message: errmsg });
          } else {
            const data = res.data.data;
            const bindInfoSet = [
              {
                bindStateKey: 'IS_BIND_FB',
                nickName: 'FB_NAME',
                bindType: 'fb'
              },
              {
                bindStateKey: 'IS_BIND_TW',
                nickName: 'TW_NAME',
                bindType: 'tw'
              },
              {
                bindStateKey: 'IS_BIND_GC',
                nickName: 'GC_NAME',
                bindType: 'gc'
              },
              {
                bindStateKey: 'IS_BIND_GP',
                nickName: 'GP_NAME',
                bindType: 'gp'
              },
              {
                bindStateKey: 'IS_BIND_NAVER',
                nickName: 'NAVER_NAME',
                bindType: 'nv'
              },
              {
                bindStateKey: 'IS_BIND_LINE',
                nickName: 'LINE_NAME',
                bindType: 'ln'
              },
              {
                bindStateKey: 'IS_BIND_APPLE',
                nickName: 'APPLE_NAME',
                bindType: 'ap'
              },
              {
                bindStateKey: 'IS_BIND_VK',
                nickName: 'VK_NAME',
                bindType: 'vk'
              },
              {
                bindStateKey: 'IS_BIND_HW',
                nickName: 'HW_NAME',
                bindType: 'hw'
              },
              {
                bindStateKey: 'IS_BIND_EMAIL',
                nickName: 'EMAIL_NAME',
                bindType: 'em'
              },
              {
                bindStateKey: 'IS_BIND_PHONE',
                nickName: 'PHONE_NAME',
                bindType: 'ph'
              }
            ];
            const bindInfo = bindInfoSet.map(item => {
              return {
                bind_status: data[item.bindStateKey] || '0',
                nick_name: data[item.nickName] || '',
                bind_type: item.bindType
              };
            });
            commit(INIT_BIND_INFO, bindInfo);
            resolve(res);
          }
        });
      });
    },
    /**
     * 绑定账号
     * @param {
     * type : 绑定的账号类型
     * } param0
     */
    [BIND_ACCOUNT]({ commit, dispatch }, type) {
      return new Promise((resolve, reject) => {
        bridge.callSdkMethod(
          BIND_ACCOUNT,
          {
            type
          },
          function (res) {
            if (parseInt(res.result, 10) == ERR_CODE) {
              commit(HIDE_DIALOG);
              // statsRequest({
              //   id: 1,
              //   la: globalConfig.getHrefParam('loginAccount'),
              //   gid: globalConfig.getHrefParam('gameId'),
              //   ext: 1, // 浮层数据
              //   e1: 'bind_award_fail',
              //   e2: '绑定领奖失败',
              // });
              setTimeout(() => {
                // dispatch(SHOW_TIPS_MSG, { message: res?.msg });
                reject(new Error(res?.msg));
              }, 500);
            } else {
              commit(INIT_BIND_INFO, res.data.bind_info);
              commit(HIDE_DIALOG);
              dispatch(REFRESH_LOGIN_STATUS).then(() => {
                dispatch(PAGE_INIT);
                // dispatch(GET_REWARD_GIFT);
              });
              // statsRequest({
              //   id: 1,
              //   la: globalConfig.getHrefParam('loginAccount'),
              //   gid: globalConfig.getHrefParam('gameId'),
              //   ext: 1, // 浮层数据
              //   e1: 'bind_award_success',
              //   e2: '绑定领奖成功',
              // });
              setTimeout(() => {
                dispatch(TOST, res?.msg);
                resolve(res);
              }, 500);
            }
          },
          {
            result: '0',
            msg: 'test error',
            data: {
              bind_info: [
                {
                  bind_type: 'fb',
                  bind_status: '1',
                  nick_name: '吴同学'
                }
              ]
            }
          }
        );
      });
    },
    [REFRESH_LOGIN_STATUS]({ dispatch }) {
      var gameId = getHrefParam('gameId');
      const link = PASSPORT_HOST + REFREH_ACTION;
      return new Promise((resolve, reject) => {
        getJSON(link, {
          gameId
        }).then(({ errmsg, res }) => {
          if (errmsg) {
            // dispatch(SHOW_TIPS_MSG, errmsg)
            reject(new Error(errmsg));
          } else {
            resolve();
          }
        });
      });
    },
    /**
     * 解绑账号
     * @param {
     * type : 绑定的账号类型
     * } param0
     */
    [DEBIND_ACCOUNT]({ commit }, type) {
      return new Promise((resolve, reject) => {
        bridge.callSdkMethod(
          DEBIND_ACCOUNT,
          {
            type
          },
          res => {
            if (res.result == ERR_CODE) {
              commit(HIDE_DIALOG);
              reject(new Error(res?.msg));
              // dispatch(SHOW_TIPS_MSG, res?.msg);
            } else {
              commit(INIT_BIND_INFO, res.data.bind_info);
              commit(HIDE_DIALOG);
              resolve();
            }
          }
        );
      });
    },
    /**
     * 检查是否开启账号删除功能
     */
    [CHECK_OPEN_DELETE]({ commit, dispatch }) {
      var gameId = getHrefParam('gameId');
      var loginAccount =
        getHrefParam('loginAccount') || getHrefParam('userName');
      var devicePlate = getHrefParam('devicePlate');
      const link = HOST + 'center_config/execute';
      return new Promise((resolve, reject) => {
        getJSON(link, {
          game_id: gameId,
          action: 'get_center_param',
          params:
            '{"user":"' + loginAccount + '","device":"' + devicePlate + '"}'
        }).then(({ errmsg, res }) => {
          if (res.result === 1) {
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },
    /**
     * 销毁账号
     */
    [DESTROY_ACCOUNT]({ commit, dispatch }, payload) {
      const link =
        PASSPORT_HOST +
        DESTROY_ACCOUNT_ACTION +
        globalConfig.getLocationSearch();

      return new Promise((resolve, reject) => {
        getJSON(link, { ...payload }).then(({ errmsg, res }) => {
          if (errmsg) {
            reject({ message: errmsg });
          } else {
            resolve();
          }
        });
      });
    },
    /**
     * 账号找回请求
     * @param {*} state
     */
    [RECOVERY_ACCOUNT]({ commit, dispatch }, payload) {
      const link = PASSPORT_HOST + RECOVERY_ACCOUNT_ACTION;
      return new Promise((resolve, reject) => {
        getJSON(link, { ...payload, needntEntryParam: true }).then(
          ({ errmsg, res }) => {
            if (errmsg) {
              reject({ message: errmsg });
            } else {
              resolve(res);
            }
          }
        );
      });
    },
    /**
     * 检查是否绑定领奖
     */
    [CHECK_BIND_REWARD]({ commit, dispatch }) {
      var gameId = getHrefParam('gameId');
      var loginAccount = getHrefParam('loginAccount');
      var devicePlate = getHrefParam('devicePlate');
      var roleId = getHrefParam('roleId');
      const link = HOST + 'river_sdk/execute';
      return new Promise((resolve, reject) => {
        getJSON(link, {
          game_id: gameId,
          action: 'get_sdk_param',
          params:
            '{"user":"' +
            loginAccount +
            '","device":"' +
            devicePlate +
            '","role_id":"' +
            roleId +
            '"}'
        }).then(({ errmsg, res }) => {
          if (res.result === 1) {
            // 是否启用绑定领奖 0不启用 1启用
            var allowBind = parseInt(res.data.allow_bind_award, 10);
            // 是否已经领取绑定领奖奖励 0未领取 1已领取
            var isBindAward = parseInt(res.data.got_bind_award, 10);
            commit(SET_ALLOW_BIND_STATE, allowBind);
            commit(SET_IS_BIND_STATE, isBindAward);
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },
    /**
     * 绑定领奖 todo
     */
    [GET_BIND_REWARD]({ dispatch }) {
      var gameId = getHrefParam('gameId');
      var serverId = getHrefParam('serverId');
      var roleId = getHrefParam('roleId');
      const link = HOST + 'river_sdk/execute';
      return new Promise((resolve, reject) => {
        getJSON(link, {
          game_id: gameId,
          action: 'get_bind_award',
          params: '{"sid":"' + serverId + '","role_id":"' + roleId + '"}'
        }).then(({ errmsg, res }) => {
          if (errmsg) {
            reject(res);
            /* dispatch(SHOW_TIPS_MSG, {
                            message: res?.msg
                        }) */
          } else {
            resolve(res);
          }
        });
      });
    },
    /**
     * 切换账号
     * type 绑定的类型
     * extend 引继码，不是引继切换则传空
     * pw:""//密码
     */
    [SWITCH_ACCOUNT]({ commit, dispatch }, { type, extend, pw }) {
      return new Promise((resolve, reject) => {
        bridge.callSdkMethod(
          SWITCH_ACCOUNT,
          {
            type,
            extend: extend || '',
            pw: pw || ''
          },
          res => {
            if (res.result == ERR_CODE) {
              setTimeout(() => {
                commit(HIDE_DIALOG);
                // 兼容提示语是json格式，如有弹窗还需额外处理
                let curMsg = res?.msg;
                try {
                  let curMsgObj = res?.msg && JSON.parse(res?.msg);
                  if (
                    Object.prototype.toString.call(curMsgObj) ===
                    '[object Object]' &&
                    curMsgObj.msg
                  ) {
                    curMsg = curMsgObj.msg;
                  }
                } catch (error) { }
                reject(new Error(curMsg));
              }, 500);
            } else {
              resolve();
            }
          }
        );
      });
    },

    [SWTICH_BY_MIGRATE]({ commit, dispatch }, { followCode, password }) {
      let validateres = validateSwitchMigrateCode({
        followCode,
        password
      });
      return new Promise((resolve, reject) => {
        if (validateres.dirty) {
          reject(new Error(validateres.errmsg));
        } else {
          dispatch(SWITCH_ACCOUNT, {
            type: 'mg',
            extend: followCode,
            pw: decodeURIComponent(encryption(password))
          })
            .then(() => {
              resolve();
            })
            .catch(errMsg => {
              reject(new Error(errMsg));
            });
        }
      });
    },

    [GET_MIGRATE]({ commit }) {
      return new Promise(resolve => {
        getJSON(PASSPORT_HOST + GET_MIGRATE_ACTION, {
          gameId: getHrefParam('gameId')
        }).then(({ errmsg, data }) => {
          // resolve(data.MIGRATE_CODE||"")
          commit(SET_FOLLOW_CODE, data.MIGRATE_CODE || '');
        });
      });
    },
    [GENERATE_MIGRATE]({ commit, dispatch }, { pw, repw }) {
      return new Promise((resolve, reject) => {
        let validateres = validateMigrateCode({ pw, repw });
        if (validateres.dirty) {
          // dispatch(SHOW_TIPS_MSG, {
          //   message: validateres.errmsg
          // })
          reject(new Error(validateres.errmsg));
        } else {
          getJSON(PASSPORT_HOST + GENERATE_MIGRATE_ACTION, {
            pw: encryption(pw),
            repw: encryption(repw),
            gameId: getHrefParam('gameId'),
            apps: getHrefParam('apps'),
            gpid: getHrefParam('gpid'),
            idfa: getHrefParam('idfa'),
            loginId: getHrefParam('loginId') || ''
          }).then(({ errmsg, data }) => {
            if (errmsg) {
              // dispatch(SHOW_TIPS_MSG, {
              //   message: errmsg
              // })
              reject(new Error(errmsg));
            } else {
              commit(SET_FOLLOW_CODE, data.MIGRATE_CODE || '');
              resolve();
            }
          });
        }
      });
    },

    [LOGOUT]({ commit }) {
      bridge.callSdkMethod(LOGOUT, {});
    },
    /**
     * 读取用户中心悬浮窗配置功能
     */
    [CHECK_FLOAT_SDK_PARAM]({ commit, dispatch }) {
      var gameId = getHrefParam('gameId');
      var loginAccount =
        getHrefParam('loginAccount') || getHrefParam('userName');
      const link = HOST + 'river_sdk/execute';
      return new Promise((resolve, reject) => {
        getJSON(link, {
          game_id: gameId,
          serverId: getHrefParam('serverId'),
          action: 'get_custom_param',
          params: JSON.stringify({
            user: loginAccount,
            serverId: getHrefParam('serverId')
          })
        }).then(({ errmsg, res }) => {
          if (res.result === 1) {
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },

    /**
     * 用户中心清除小红点
     */
    [CLEAR_RED_POINT]({ commit, dispatch }, configId) {
      var gameId = getHrefParam('gameId');
      var loginAccount =
        getHrefParam('loginAccount') || getHrefParam('userName');
      var devicePlate = getHrefParam('devicePlate');
      const link = HOST + 'river_sdk/execute';
      return new Promise((resolve, reject) => {
        getJSON(link, {
          game_id: gameId,
          action: 'clear_red_point',
          params:
            '{"user":"' +
            loginAccount +
            '","device":"' +
            devicePlate +
            '","config_id":"' +
            configId +
            '"}'
        }).then(({ errmsg, res }) => {
          if (res.result === 1) {
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },

    // 用户中心获取玩家订阅状态
    [GET_USER_SUB]({ commit, dispatch }, payload) {
      const link = PASSPORT_HOST + GET_USER_SUB_ACTION;
      return new Promise((resolve, reject) => {
        getJSON(link, { ...payload, needntEntryParam: true }).then(
          ({ errmsg, res }) => {
            if (errmsg) {
              reject({ message: errmsg });
            } else {
              resolve(res);
            }
          }
        );
      });
    },
    // 用户中心ios账号删除苹果登录REST API 撤销用户令牌
    [IOS_REVOKE]({ commit, state }, params) {
      const link = PASSPORT_HOST + UNABLE_TOKEN_ACTION;
      return new Promise(resolve => {
        post(link, params, {
          withCredentials: true
        }).then(({ res }) => {
          resolve(res);
        });
      });
    },
    /**
     * 检查是否可自动解绑
     */
    [CHECK_DEBIND](_context, params) {
      const checkAction = PASSPORT_HOST + 'center/unbind/verify';
      return new Promise((resolve, reject) => {
        post(checkAction, Object.assign({}, params, { type: '' }), {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            resolve(res);
          } else {
            reject({ errmsg, res });
          }
        });
      });
    },
    /**
     * 后端解绑
     */
    [DO_DEBIND]({ commit }, params) {
      const debindAction = PASSPORT_HOST + 'center/unbind';
      return new Promise((resolve, reject) => {
        post(debindAction, Object.assign({}, params, { type: '' }), {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            commit(UPDATE_BIND_INFO, {
              type: params.type,
              status: DEBIND_STATE
            });
            resolve(res);
          } else {
            reject({ errmsg, res });
          }
        });
      });
    },
    // 获取可解绑社交账号类型
    [GET_CAN_DEBIND_TYPE]({ commit }, params) {
      const getAction = PASSPORT_HOST + 'center/unbind/fetch';
      return new Promise((resolve, reject) => {
        post(getAction, Object.assign({}, params), {
          withCredentials: true
        }).then(({ errmsg, res }) => {
          if (!errmsg) {
            if (res && res.data && res.data.length) {
              commit(SET_CAN_DEBIND_TYPE, res.data);
            } else {
              commit(SET_CAN_DEBIND_TYPE, []);
            }
            resolve({ errmsg, res });
          } else {
            reject({ errmsg, res });
          }
        });
      });
    },

    /**
     * 读取用户中心客服公告
     */
    [GET_NOTICE_POPUP](_context, param) {
      return new Promise((resolve, reject) => {
        getJSON(SUPPORT_REQ_URL + '/getAnnouncement', param).then(({ res }) => {
          if (res.result === 1) {
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },
    /**
     * 发送用户中心客服公告显示记录
     */
    [SEND_SHOW_NOTICE_RECORD](_context, param) {
      return new Promise((resolve, reject) => {
        getJSON(SUPPORT_REQ_URL + '/triggerAnnouncement', param).then(
          ({ res }) => {
            if (res.result === 1) {
              resolve(res);
            } else {
              reject(res);
            }
          }
        );
      });
    },
    /**
     * 读取用户中心版主开关
     */
    [GET_MODS_POPUP](_context, param) {
      return new Promise((resolve, reject) => {
        getJSON(SUPPORT_REQ_URL + '/isShowMod', param).then(({ res }) => {
          if (res.result === 1) {
            resolve(res);
          } else {
            reject(res);
          }
        });
      });
    },
    /**
     * 获取平台账号邮箱验证码
     */
    [GET_PLATFORM_EMAIL_CODE](_context, param) {
      return new Promise((resolve, reject) => {
        get(PASSPORT_HOST + 'h5_email/send_ebl', {
          email: decodeURIComponent(encryption(param.email)),
          action_kind: param.actionKind,
          gameId: globalConfig.getHrefParam('gameId')
        }).then(({ errmsg, res }) => {
          let resp = res?.data;
          if (!errmsg) {
            // 错误会返回axios的整个res
            resp = res;
          }
          if (+resp?.result === 1) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    /**
     * 获取平台账号手机验证码
     */
    [GET_PLATFORM_PHONE_CODE](_context, param) {
      return new Promise((resolve, reject) => {
        get(PASSPORT_HOST + 'h5_phone/send_ebl', {
          phone: decodeURIComponent(encryption(param.phone)),
          phoneCode: param.phoneCode,
          action_kind: param.actionKind,
          gameId: globalConfig.getHrefParam('gameId')
        }).then(({ errmsg, res }) => {
          let resp = res?.data;
          if (!errmsg) {
            // 错误会返回axios的整个res
            resp = res;
          }
          if (+resp?.result === 1) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    /**
     * 平台账号邮箱绑定
     */
    [BIND_PLATFORM_EMAIL]({ state }, param) {
      return new Promise((resolve, reject) => {
        get(PASSPORT_HOST + 'h5_email/bind', {
          // email: md5(param.email + uid + loginToken + gameId + timeStamp),
          email: decodeURIComponent(encryption(param.email)),
          code: param.code,
          uid: state.userId || globalConfig.getHrefParam('userId'),
          game_id: globalConfig.getHrefParam('gameId'),
          checkIsBind: param.checkIsBind || 0,
          sendDiscount: param.sendDiscount
        }).then(({ errmsg, res }) => {
          let resp = res?.data;
          if (!errmsg) {
            // 错误会返回axios的整个res
            resp = res;
          }
          if (+resp.result === 1) {
            resolve(resp);
          } else {
            reject(resp);
          }
        });
      });
    },
    /**
     * 平台账号手机绑定
     */
    [BIND_PLATFORM_PHONE]({ state }, param) {
      return new Promise((resolve, reject) => {
        get(PASSPORT_HOST + 'h5_phone/bind', {
          // email: md5(param.email + uid + loginToken + gameId + timeStamp),
          phone: decodeURIComponent(encryption(param.phone)),
          phoneCode: param.phoneCode,
          code: param.code,
          uid: state.userId || globalConfig.getHrefParam('userId'),
          game_id: globalConfig.getHrefParam('gameId'),
          checkIsBind: param.checkIsBind || 0,
          sendDiscount: param.sendDiscount
        }).then(({ errmsg, res }) => {
          let resp = res?.data;
          if (!errmsg) {
            // 错误会返回axios的整个res
            resp = res;
          }
          if (+resp.result === 1) {
            resolve(resp);
          } else {
            reject(resp);
          }
        });
      });
    },
    /**
     * 获取绑定的平台账号（手机或邮箱）
     * kink: phone | email
     */
    [GET_PLATFORM_BIND_INFO](_context, kind) {
      return new Promise((resolve, reject) => {
        get(PASSPORT_HOST + 'center/user_info/get_info_channel', {
          kind,
          gameId: globalConfig.getHrefParam('gameId')
        }).then(({ errmsg, res }) => {
          let resp = res?.data;
          if (!errmsg) {
            // 错误会返回axios的整个res
            resp = res;
          }
          if (+resp.result === 1) {
            resolve(resp);
          } else {
            reject(resp);
          }
        });
      });
    },
    [UPDATE_KR_TERMS_SELECT]({ commit }, selectValue) {
      commit(UPDATE_KR_TERMS_SELECT, selectValue);
      globalConfig.setCookie(KR_TERMS_SELECT, selectValue);
    },
    [UPDATE_US_TERMS_SELECT]({ commit }, selectValue) {
      commit(UPDATE_US_TERMS_SELECT, selectValue);
      globalConfig.setCookie(US_TERMS_SELECT, selectValue);
    },
    [UPDATE_DMA_SELECT]({ commit }, selectValue) {
      commit(UPDATE_DMA_SELECT, selectValue);
      globalConfig.setCookie(DMA_SELECT, selectValue);
    }
  }
};
